var app = angular.module("leonardo");

var WorkOrderStates = function($stateProvider) {

  $stateProvider.state('work-orders', {
    url: '/work-orders',
    parent: 'authenticated.layout-main',
    views: {
      'user': {
        templateUrl: 'views/templates/user/logged.html',
        controller: 'UserMenu'
      }
    },
    redirectTo: function (PermissionService) {
      let user = PermissionService.authDataService.authData.user;
      if (user && (!user.is_staff && !user.is_white_label_admin)) {
        return 'work-orders.list';
      }
      else {
        return 'work-orders.custom-values';
      }
    },
    ncyBreadcrumb: {
      label : '{{ filterService.getLabelProperty() }}'
    }
  });

  $stateProvider.state('work-orders.list', {
    url: "/list",
    title: 'Work Orders',
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/work-order-list.html',
        controller: 'WorkOrderActions'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/work-order/list.html',
        controller: 'WorkOrderList'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'WorkOrderListFilters'
      }
    },
    ncyBreadcrumb: {
      label: 'Work Orders'
    }
  });

  $stateProvider.state('work-orders.custom-values', {
    url: "/custom-values",
    views: {
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/work-order-values.html',
        controller: 'WorkOrderActions'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/work-order/custom-values-list.html',
        controller: 'WorkOrderValues'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'WorkOrderValuesFilters'
      }
    },
    ncyBreadcrumb: {
      label: 'Work Order Custom Values'
    }
  });

  $stateProvider.state('work-orders.add', {
    url: "/add",
    action: 'create',
    views: {
      'filters@authenticated.layout-main': {},
      'actions@authenticated.layout-main': {},
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/work-order/form.html',
        controller: 'WorkOrderForm'
      }
    },
    resolve: {
      workOrderOjb: ['WorkOrderService', function(WorkOrderService) {
        return null;
      }]
    },
    ncyBreadcrumb: {
      label: 'Add Work Order'
    }
  });

  $stateProvider.state('work-orders.edit', {
    url: "/:pk/edit",
    action: 'edit',
    params: {
      pk: '',
      squash: false
    },
    views: {
      'filters@authenticated.layout-main': {},
      'actions@authenticated.layout-main': {},
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/work-order/form.html',
        controller: 'WorkOrderForm'
      }
    },
    resolve: {
      workOrderOjb: ['WorkOrderService', '$stateParams', function(WorkOrderService, $stateParams) {
        return WorkOrderService.get($stateParams.pk);
      }]
    },
    ncyBreadcrumb: {
      label: 'Edit Work Order'
    }
  });

  $stateProvider.state('work-orders.custom-values.add', {
    url: "/add",
    title: 'Add Custom Value',
    action: 'create',
    views: {
      'filters@authenticated.layout-main': {},
      'actions@authenticated.layout-main': {},
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/work-order/form-value.html',
        controller: 'WorkOrderValueForm'
      }
    },
    resolve: {
      workOrderValOjb: ['WorkOrderCVService', function(WorkOrderCVService) {
        return null;
      }]
    },
    ncyBreadcrumb: {
      label: 'Add Custom Value'
    }
  });

  $stateProvider.state('work-orders.custom-values.edit', {
    url: "/:pk/edit",
    title: 'Edit Custom Value',
    action: 'edit',
    params: {
      pk: '',
      squash: false
    },
    views: {
      'filters@authenticated.layout-main': {},
      'actions@authenticated.layout-main': {},
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/work-order/form-value.html',
        controller: 'WorkOrderValueForm'
      }
    },
    resolve: {
      workOrderValOjb: ['WorkOrderCVService', '$stateParams', function(WorkOrderCVService, $stateParams) {
        return WorkOrderCVService.get($stateParams.pk);
      }]
    },
    ncyBreadcrumb: {
      label: 'Edit Custom Value'
    }
  });

};

app.config(['$stateProvider', WorkOrderStates]);
